<!-- =========================================================================================
  File Name: modifySiderBar.vue
  Description: Modify sider bar
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="modify-sidebar items-no-padding" spacer v-model="isSidebarActive">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{title}}</h4>
      <feather-icon icon="XIcon" @click.stop="close" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6">
      <slot></slot>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" @click="confirm">{{confirmText}}</vs-button>
      <vs-button type="border" color="danger" @click="close">{{cancelText}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    title: {
      type: String,
      default: '编辑'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },
  data() {
    return {
      isSidebarActive: false
    }
  },
  methods: {
    open() {
      this.isSidebarActive = true
    },
    close() {
      this.isSidebarActive = false
    },
    confirm() {
      this.$emit('confirm')
    }
  },
  components: {
    VuePerfectScrollbar,
  }
}
</script>

<style lang="scss" scoped>
.modify-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52004;
  }

  /deep/ .vs-sidebar {
    z-index: 52004;
    width: 520px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>
